module.exports = __webpack_public_path__ + "static/media/background-image.40b59199.png";